import script from "./Promotion.vue?vue&type=script&setup=true&lang=js"
export * from "./Promotion.vue?vue&type=script&setup=true&lang=js"

import "./Promotion.vue?vue&type=style&index=0&id=65e77d89&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65e77d89"]])

export default __exports__